import React from 'react';
import { MarketingHeadlineAccent } from './MarketingHeadlineAccent';
import { useMaxWidth } from '../../hooks/useIsMobile';

/**
 * Renders headline copy with optional mobile-only line breaks.
 * On desktop, uses the full `text` string so phrasing and spacing stay correct.
 */
export function MarketingResponsiveHeadline({ text, mobileLines, accent, className }) {
  const isMobileLayout = useMaxWidth(768);

  if (!mobileLines?.length || !isMobileLayout) {
    return <MarketingHeadlineAccent text={text} accent={accent} className={className} />;
  }

  return mobileLines.map((line, i) => (
    <span
      key={i}
      className={
        i === 0
          ? 'landing-headline-mobile-line landing-headline-mobile-line--first'
          : 'landing-headline-mobile-line'
      }
    >
      <MarketingHeadlineAccent text={line} accent={accent} className={className} />
    </span>
  ));
}
